import AnimatedProgress from './AnimatedProgress';

export default AnimatedProgress;
